<div class="container mx-auto px-4 sm:px-6 lg:px-8">
  <!-- Encabezado -->
  <div class="text-center mb-12">
    <!-- <h2 class="text-4xl md:text-5xl font-extrabold text-gray-800 dark:text-white">Hola {{ profile.name.full_name }} 👋</h2> -->
    <h1 class="text-4xl md:text-5xl font-extrabold text-gray-800 dark:text-white pt-6 tracking-tight">Bienvenido a la Comunidad</h1>
    <p class="mt-4 text-lg text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
      Conéctate, comparte y crece con otros miembros. Descubre eventos, foros y experiencias únicas.
    </p>
  </div>

  <!-- CTA: ¿Qué puedes hacer aquí? -->
  <div class="grid md:grid-cols-3 gap-6 mb-16">
    <div class="bg-white dark:bg-gray-900 rounded-xl shadow-md p-6 flex items-start gap-4 hover:shadow-xl transition-all duration-300">
      <div class="text-blue-600 dark:text-blue-400 text-3xl">📣</div>
      <div>
        <h3 class="text-lg font-semibold text-gray-800 dark:text-white">Publicar eventos</h3>
        <p class="text-sm text-gray-600 dark:text-gray-400">Organiza encuentros y comparte tus conocimientos.</p>
      </div>
    </div>
    <div class="bg-white dark:bg-gray-900 rounded-xl shadow-md p-6 flex items-start gap-4 hover:shadow-xl transition-all duration-300">
      <div class="text-green-600 dark:text-green-400 text-3xl">💬</div>
      <div>
        <h3 class="text-lg font-semibold text-gray-800 dark:text-white">Participar en foros</h3>
        <p class="text-sm text-gray-600 dark:text-gray-400">Inicia o únete a debates útiles sobre temas variados.</p>
      </div>
    </div>
    <div class="bg-white dark:bg-gray-900 rounded-xl shadow-md p-6 flex items-start gap-4 hover:shadow-xl transition-all duration-300">
      <div class="text-purple-600 dark:text-purple-400 text-3xl">👥</div>
      <div>
        <h3 class="text-lg font-semibold text-gray-800 dark:text-white">Conectar con otros</h3>
        <p class="text-sm text-gray-600 dark:text-gray-400">Conoce personas con intereses en común.</p>
      </div>
    </div>
  </div>

  <!-- Publicaciones -->
  <div class="grid md:grid-cols-2 gap-8">
    <div class="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 transition-transform hover:scale-105">
      <h2 class="text-xl font-bold text-gray-800 dark:text-white">
        📢 Evento:
        <span class="bg-azulOscuro text-white px-2 rounded">BOOTCAMP</span>
        <span class="bg-red-600 text-white px-2 rounded">GERENTES TALLERES</span> 2025
      </h2>
      <p class="text-gray-600 dark:text-gray-400 mt-2">Aprende como administrar tus talleres.</p>
      <div class="mt-4 text-sm text-gray-500 dark:text-gray-400 flex justify-between items-center">
        <span>🗓 10 de mayo - 🕒 9:00 AM - 🌎 Pereira - Colombia</span>
        <span
          (click)="verMasBootcamp()"
          class="text-primary font-medium hover:text-primary cursor-pointer"
          >Ver más</span
        >
      </div>
    </div>


    <div class="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 transition-transform hover:scale-105">
      <h2 class="text-xl font-bold text-gray-800 dark:text-white">🗨️ Foro: ¿Cuál es la mejor marca de aceite?</h2>
      <p class="text-gray-600 dark:text-gray-400 mt-2">Comparte tu experiencia con diferentes marcas de lubricantes.</p>
      <div class="mt-4 text-sm text-gray-500 dark:text-gray-400 flex justify-between items-center">
        <span>👤 CarlosM | 💬 12 respuestas</span>
        <span (click)="verMasForo()" class="text-primary font-medium hover:text-primary cursor-pointer">Ver más</span>
      </div>
    </div>

    <!-- Puedes añadir más tarjetas dinámicamente aquí -->
  </div>
    <!-- Modal flotante para BOOTCAMP -->
    <div
    *ngIf="isBootcamp"
    class="fixed inset-0 backdrop-blur-xl bg-black bg-opacity-50 flex items-center justify-center z-50"
  >
    <div class="bg-white dark:bg-gray-900 rounded-xl shadow-lg max-w-2xl w-full p-6 relative">
      <button
        class="absolute top-3 right-3 text-gray-600 dark:text-gray-300 hover:text-red-600 text-xl"
        (click)="cerrar()"
      >
        &times;
      </button>
      <h2 class="text-2xl font-bold text-gray-800 dark:text-white mb-4">BOOTCAMP INTERNACIONAL</h2>
      <div class="aspect-w-16 aspect-h-9 mb-4">
        <iframe
          class="w-full h-64 rounded"
          src="https://www.youtube.com/embed/qjnyy8d0XaM?si=aiVZDyUeoIOdslat"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
        ></iframe>
      </div>
      <p class="text-gray-700 dark:text-gray-300 mb-2">Anímate a participar en nuestro Bootcamp Internacional.</p>
      <p class="text-gray-700 dark:text-gray-300 mb-2">Aprende a administrar tus talleres.</p>
      <p class="text-gray-700 dark:text-gray-300 mb-4">Tenemos un invitado especial para ti:</p>
      <strong class="text-red-600 dark:text-red-400">Jorge Ordoñez</strong>
    </div>
  </div>

  <!--Modal flotante para el FORO-->
  <div
  *ngIf="isForo"
  class="fixed inset-0 backdrop-blur-xl bg-black bg-opacity-50 flex items-center justify-center z-50"
>
  <div class="bg-white dark:bg-gray-900 rounded-xl shadow-lg max-w-2xl w-full p-6 relative">
    <button
      class="absolute top-3 right-3 text-gray-600 dark:text-gray-300 hover:text-red-600 text-xl"
      (click)="cerrar()"
    >
      &times;
    </button>
    <h2 class="text-2xl font-bold text-gray-800 dark:text-white mb-4">¿Cuál es la mejor marca de aceite?</h2>
    <div class="aspect-w-16 aspect-h-9 mb-4">
      <img src="https://www.mundodeportivo.com/files/article_gallery_microformat/uploads/2024/06/04/665f0fe6ad8f6.jpeg" alt="">
    </div>
    <p class="text-gray-700 dark:text-gray-300 mb-2">🗨️Carlos: Es el mejor aceite para mi vehiculo🎉🤯</p>
    <p class="text-gray-700 dark:text-gray-300 mb-2">🗨️Andres: El mejor sin duda😎</p>
    <p class="text-gray-700 dark:text-gray-300 mb-4">🗨️Jorge: Recomendadisimo 🌟☺️</p>
    <!-- <strong class="text-red-600 dark:text-red-400">Jorge Ordoñez</strong> -->
  </div>
</div>

  <!-- Botón flotante de acción -->
  <button
    class="fixed bottom-6 right-6 bg-blue-600 hover:bg-blue-700 text-white p-4 rounded-full shadow-xl transition duration-300 transform hover:scale-110 focus:outline-none focus:ring-4 focus:ring-blue-400 z-50"
    title="Crear nueva publicación"
  >
    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
    </svg>
  </button>
</div>
